<template>
    <div class="divisionNotice">
        <div class="info-box">
            <div class="line">
                <p class="title">学校</p>
                <p class="val">{{viewData.schoolName}}</p>
            </div>
            <div class="line">
                <p class="title">视导日期</p>
                <p class="val">{{viewData.supervisionDate}}</p>
            </div>
            <div class="line">
                <p class="title">学科</p>
                <p class="val">
                    <span v-for="(item,index) in subjectList" :key="index">
                      <span v-show="index!=0">、</span>{{item.stageSubjectName}}
                    </span>
                </p>
            </div>
            <div class="line">
                <p class="title">分配人数</p>
                <p class="val">{{viewData.professionalSum}}人</p>
            </div>
        </div>
        <div class="btn-box">
            <van-button
                type="primary"
                block
                size="large"
                color="#334EB4"
                @click="openManagPage"
                round>立即确认</van-button>
        </div>
    </div>
</template>
<script>
import { getPlanDistributionInfo } from '@/api/common';
export default {
  data() {
    return {
      planId: '',
      viewData: {},
      subjectList: []
    };
  },
  beforeRouteEnter(to, from, next) {
    // 清除分配评课专家页面保存的store
    next((vm) => {
      vm.$store.commit('SET_SELECT_EXPERTS_LIST', []);
    });
  },
  mounted() {
    this.planId = this.$route.query.planId;
    this.getPlanInfo();
  },
  methods: {
    getPlanInfo() {
      getPlanDistributionInfo(this.planId).then(res => {
        this.viewData = res.data;
        for (let j = 0; j < this.viewData.stageSubjectVOS.length; j++) {
          const subject = this.viewData.stageSubjectVOS[j];
          const teachers = subject.subjectNameVOS;
          for (let k = 0; k < teachers.length; k++) {
            const teacher = teachers[k];
            this.subjectList.push({ stageSubjectName: subject.stageName + teacher.subjectName });
          }
        }
      });
    },
    openManagPage() {
      window.location.href = `${window.location.origin}/manage.html#/expertDetail?type=handle&distributionFlag=0&planId=${this.viewData.planId}`;
    }
  }
};
</script>
<style lang="scss" scoped>
.divisionNotice{
    .info-box{
        background: #fff;
        margin: 15px;
        padding:0 15px;
        .line{
            border-bottom: 1px dashed #BBBBBB;
            font-size: 13px;
            display: flex;
            justify-content: space-between;
            padding: 20px 0;
            &:last-child{
                border-bottom: 0px;
            }
            .title{
                color: #999999;
                width: 25%;
            }
            .val{
                color: #333333;
                text-align: right;
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-end;
            }
        }
    }
    .btn-box{
        position: fixed;
        bottom: 40px;
        left: 16px;
        right: 16px;
    }
}
</style>
